// src/store/services/EventosVentasEntradass.js
import feathersClient, { makeServicePlugin, BaseModel } from "../../feathers-client";

class EventosVentasEntradas extends BaseModel { }
EventosVentasEntradas.modelName = "EventosVentasEntradas";
EventosVentasEntradas.instanceDefaults = () => {
    return {
    };
};
const servicePath = "eventos-ventas-entradas";
const servicePlugin = makeServicePlugin({
    Model: EventosVentasEntradas,
    service: feathersClient.service(servicePath),
    servicePath,
});

export default servicePlugin;
